// src/components/common/Header.tsx
import { Menu } from 'lucide-react';

import { LanguageSwitcher, ThemeToggle, SearchBar, NotificationsDropdown, UserMenu } from '@/components/common';
import { Button } from "@/components/ui";

type HeaderProps = {
    onMenuClick: () => void;
};

export default function Header({ onMenuClick }: HeaderProps) {
    return (
        <header className="h-16 flex items-center justify-between px-6 bg-background border-b sticky top-0 z-10">
            {/* Left Section - Search */}
            <div className="flex items-center gap-6">
                {/* Mobile Menu Toggle */}
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={onMenuClick}
                    className="md:hidden"
                >
                    <Menu className="h-5 w-5" />
                </Button>

                {/* Search */}
                <SearchBar />
            </div>

            {/* Right Section - Icons */}
            <div className="flex items-center space-x-2">
                {/* Language Selector */}
                <LanguageSwitcher variant="icon" />

                {/* Theme Toggle */}
                <ThemeToggle />

                {/* Notifications Dropdown */}
                <NotificationsDropdown />

                {/* User Menu */}
                <UserMenu />
            </div>
        </header>
    );
}